import { render, staticRenderFns } from "./AllCountryTabContent.vue?vue&type=template&id=2bc061f3&scoped=true&"
import script from "./AllCountryTabContent.vue?vue&type=script&lang=js&"
export * from "./AllCountryTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc061f3",
  null
  
)

export default component.exports